/* eslint-disable sort-keys */
import type { ValueOf } from '@/types';

// * ClientInteractions module will convert events to lowercase

const PRIMARY_EVENTS = {
  /** Marks the start of loading the app in index.html */
  START_APPLICATION: 'START_APPLICATION',
  /** Marks the app loading phase when routing kicks in, customer sees a spinner */
  APP_ROUTING: 'APP_ROUTING',

  /** After render of Pay Now (bank and cc) or Pay Later, waiting for user to click the CTA */
  GUEST_XO_SIGNUP_FORM_USER_INPUT: 'GUEST_XO_SIGNUP_FORM_USER_INPUT',

  /** Toggles the "same_as_shipping" checkbox, and shows/hides billing address entry fields */
  SAME_AS_SHIPPING_ADDRESS_RENDER: 'SAME_AS_SHIPPING_ADDRESS_RENDER',

  /** Currency conversion component (selection) is rendered on the page */
  CURRENCY_CONVERSION_RENDER: 'CURRENCY_CONVERSION_RENDER',

  /** Shipping address change callback is called */
  GUEST_SHIPPING_ADDRESS_CHANGE_CALLBACK:
    'GUEST_SHIPPING_ADDRESS_CHANGE_CALLBACK',
  /** Shipping options change callback is called */
  GUEST_SHIPPING_OPTIONS_CHANGE_CALLBACK:
    'GUEST_SHIPPING_OPTIONS_CHANGE_CALLBACK',

  /** IWC Auth provider rendered on iwc landing page */
  GUEST_IWC_LANDING_RENDER: 'GUEST_IWC_LANDING_RENDER',
  /** User attempts to login on IWC landing page via OTP */
  GUEST_IWC_LANDING_OTP_LOGIN_SUBMIT: 'GUEST_IWC_LANDING_OTP_LOGIN_SUBMIT',
  /** User attempts to login on IWC landing page via Password */
  GUEST_IWC_LANDING_PWD_LOGIN_SUBMIT: 'GUEST_IWC_LANDING_PWD_LOGIN_SUBMIT',
  /** User attempts to login on OTP In-Context interstitial page via OTP code */
  GUEST_IWC_INCONTEXT_OTP_LOGIN_SUBMIT: 'GUEST_IWC_INCONTEXT_OTP_LOGIN_SUBMIT',
  /** Customer selects Apple Pay option on Billing/BASL flow. Apple pay is then rendered (by OS) */
  APPLE_PAY_BASL_RENDER: 'APPLE_PAY_BASL_RENDER',
  /** Customer selects Apple Pay option on IWC Landing page (apple pay is rendered by OS) */
  APPLE_PAY_IWC_LANDING_RENDER: 'APPLE_PAY_IWC_LANDING_RENDER',

  /** Customer clicked the Pay Bank tab (Pay with bank, e.g. DE country / JP) */
  PAY_BANK_RENDER: 'PAY_BANK_RENDER',
  /** Customer clicked the Pay Later tab (BNPL) */
  PAY_LATER_RENDER: 'PAY_LATER_RENDER',
  /** Customer clicked the Pay Now tab (Credit Card) */
  PAY_NOW_RENDER: 'PAY_NOW_RENDER',

  /** After render of Real Money Gaming page waiting for user to click the CTA */
  RMG_PAGE_USER_INPUT: 'RMG_PAGE_USER_INPUT',

  /** After successful payment complete, display passkey enrollment page if eligible */
  PASSKEY_PAGE_AFTER_PAYMENT_COMPLETE: 'PASSKEY_PAGE_AFTER_PAYMENT_COMPLETE',
} as const;

const SUBMISSION_EVENTS = {
  /** Customer submits to create and account and pay */
  CREATE_ACCOUNT_AND_PAY_SUBMIT: 'CREATE_ACCOUNT_AND_PAY_SUBMIT',
  /** Customer submits to pay using a guest account */
  GUEST_PAY_SUBMIT: 'GUEST_PAY_SUBMIT',
  /** Customer submits to pay when in member match */
  MEMBER_MATCH_PAY_SUBMIT: 'MEMBER_MATCH_PAY_SUBMIT',
} as const;

const CONTINGENCY_EVENTS = {
  /** Customer clicked the Pay Bank tab, then needed to navigate(via redirect) to consumer
   to fulfill that for specific countries like JP that have no add_bank flow in weasley  (JP)) */
  ADD_BANK_REDIRECT_TO_CONSUMER: 'ADD_BANK_REDIRECT_TO_CONSUMER',

  /** Bank account already linked - Customer chose to link a bank account on member */
  ADD_BANK_REDIRECT_TO_MEMBER: 'ADD_BANK_REDIRECT_TO_MEMBER',

  /**Marks the start of Member benefits contigency */
  CONTINGENCY_ACCOUNT_BENEFITS_USER_INPUT:
    'CONTINGENCY_ACCOUNT_BENEFITS_USER_INPUT',

  /** Address Normalization verify address prompt is shown to customer */
  CONTINGENCY_ADDRESS_NORMALIZATION_USER_INPUT:
    'CONTINGENCY_ADDRESS_NORMALIZATION_USER_INPUT',
  /** Bank account already linked - Customer must link new bank account */
  CONTINGENCY_BANK_ACCT_ALREADY_LINKED_USER_INPUT:
    'CONTINGENCY_BANK_ACCT_ALREADY_LINKED_USER_INPUT',
  /** 3DS Contingency - Customer must resolve 3DS to continue */
  CONTINGENCY_RESOLVE_3DS_USER_INPUT: 'CONTINGENCY_RESOLVE_3DS_USER_INPUT',
  /** AU customers must resolve the CRS tax interstitial to continue */
  CONTINGENCY_TAX_INFORMATION_USER_INPUT:
    'CONTINGENCY_TAX_INFORMATION_USER_INPUT',
} as const;

export const CUSTOMER_INTERACTION = {
  ...PRIMARY_EVENTS,
  ...SUBMISSION_EVENTS,
  ...CONTINGENCY_EVENTS,
};

export type CustomerInteractionType = typeof CUSTOMER_INTERACTION;
export type CustomerInteraction = ValueOf<CustomerInteractionType>;
